import { RootState } from "@/app/store/type";
import { createSelector } from "@reduxjs/toolkit";

const selectItems = (state: RootState) => state.menu.items;

export const selectMenuItems = createSelector(
    [selectItems],
    (items) => Object.values(items)
);

export const selectMobileSidebarOpen = (state: RootState) => state.menu.open;